module.exports = __webpack_public_path__ + "img/sousuo.8832f2a.svg";